module.exports = __webpack_public_path__ + "static/media/SPORT.1eadef44.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/SPORT.jpg
// module id = 1778
// module chunks = 1